export const GET_PRICE_GAP_START='GET_PRICE_GAP_START';
export const GET_PRICE_GAP_SUCCESS='GET_PRICE_GAP_SUCCESS';
export const GET_PRICE_GAP_FAIL='GET_PRICE_GAP_FAIL';

export const UPDATE_PRICE_GAP_START='UPDATE_PRICE_GAP_START';
export const UPDATE_PRICE_GAP_SUCCESS='UPDATE_PRICE_GAP_SUCCESS';
export const UPDATE_PRICE_GAP_FAIL='UPDATE_PRICE_GAP_FAIL';

export const TOGGLE_PRICE_GAP_UPDATE='TOGGLE_PRICE_GAP_UPDATE';